import {useEffect} from 'react';
import {useLocation} from 'react-router';
import {login} from './keycloak';

/**
 * `/login?loginHint=<email>`: starts the Keycloak login and returns to the start page afterwards.
 * Used by links in e-mails.
 */
export default function LoginRedirect() {
  const location = useLocation();
  useEffect(() => {
    const loginHint = new URLSearchParams(location.search).get('loginHint') ?? undefined;
    void login({redirectUri: window.location.origin, loginHint});
  }, [location.search]);
  return <b>Redirecting...</b>;
}
